import React, { useState } from "react";
import SupplierSidebar from "../../components/Seller/SupplierSidebar";
import AuthNavbar from "../../components/common/AuthNavbar";
import FooterDashBoard from "../../components/AdminSideComponents/DashBoardFooter/FooterDashBoard";

const SupplierLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      <AuthNavbar setIsSidebarOpen={setIsSidebarOpen} userRole="supplier" />
      <div style={{ display: "flex" }} className="mt-[10px]">
        <div className="lg:w-[15%] h-[100vh]">
          <SupplierSidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </div>

        <main className="lg:w-[90%] w-[100%] h-[100vh] overflow-y-scroll">
          {children}
          <FooterDashBoard />
        </main>
      </div>
    </React.Fragment>
  );
};

export default SupplierLayout;